import { Component } from '@angular/core';

import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { PageEditorService } from '../workspace/page-editor.service';
import { PanelNavService } from '../workspace/panel-nav.service';
import { SubRegionsService } from '../workspace/subregions.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';

/**
 * The Regions panel (#256, #260): every region with its sub-regions under it. A region opens in the Regions editor;
 * a sub-region can be opened, recoloured, its page edited, or deleted (when empty and off the website); new regions
 * and sub-regions start here. Publishing a region stays on the Regions card.
 */
@Component({
  selector: 'app-suburb-regions-panel',
  templateUrl: './suburb-regions-panel.component.html',
  styleUrls: ['./suburb-regions-panel.component.scss'],
})
export class SuburbRegionsPanelComponent {
  /** The sub-region whose colour picker is open. */
  colourFor: string | null = null;

  constructor(
    public state: WorkspaceStateService,
    public catalogue: SuburbCatalogueService,
    public subRegions: SubRegionsService,
    public pageEditor: PageEditorService,
    public nav: PanelNavService
  ) {}

  toggleColours(id: string): void {
    this.colourFor = this.colourFor === id ? null : id;
  }

  pickColour(id: string, slot: number): void {
    this.colourFor = null;
    this.subRegions.setColour(id, slot);
  }
}
